<template lang="pug">
.user-team-full-select
  p.user-team-full-select__title
    | {{title}}
  UiInput.user-team-full-select__input(
    title="Поиск"
    placeholder="Введите название команды"
    icon="ui-search"

    v-model="input"
  )
  .user-team-full-select__option-wrap
    .user-team-full-select__option
      template(v-if="!loading")
        SelectOption(
          v-for="item in filterOption" :key="item.id"
          v-bind="item"

          :class="{'-active-': item.id === value }"

          @click.native="selectValue(item.id)"
        )
      template(v-else)
        EmptyOption(
          v-for="i in 3" :key="i"
        )
    p.side-container__subtitle.-dark-(v-if="!loading && !filterOption.length")
      | Нет доступных команд


</template>

<script>
import SelectOption from './SelectOption';
import EmptyOption from './EmptyOption';
export default {
  components: {
    SelectOption,
    EmptyOption
  },
  props: {
    value: {},
    title: {},
    option: {},
    loading: {}
  },
  data: () => ({
    input: ''
  }),
  computed: {
    filterOption() {
      return this.option.filter(item =>
        item.mainValue.toLowerCase().includes(this.input.toLowerCase())
      );
    }
  },
  methods: {
    selectValue(value) {
      this.$emit('input', value);
    }
  }
};
</script>
